import { DocumentReference } from "firebase/firestore";

import { FirestoreOfflineDocument } from "@/core/modules/firestore/objects/FirestoreOfflineDocument";
import { LimitationDuration } from "./LimitationDuration";

import { EnumField, NumberWithDefaultField, StringField } from "@/core/fields";

export class Limitation extends FirestoreOfflineDocument {
  public name: string | undefined = undefined;
  public duration: LimitationDuration = LimitationDuration.Permanent;
  public order = 999;

  public constructor(firestoreData?: Record<string, unknown>, id?: string) {
    super(id);
    if (firestoreData !== undefined) this.fromFirestore(firestoreData, id);
  }

  public fromFirestore(data: Record<string, unknown>, id?: string, firestoreRef?: DocumentReference): Limitation {
    super.fromFirestore(data, id, firestoreRef);

    this.name = StringField.fromFirestore(data.name);
    this.duration = EnumField.fromFirestore<LimitationDuration>(data.duration, Object.values(LimitationDuration), LimitationDuration.Permanent);
    this.order = NumberWithDefaultField.fromFirestore(data.order, 999);

    return this;
  }

  public toFirestore(): Record<string, unknown> {
    const firestoreData: Record<string, unknown> = super.toFirestore();

    firestoreData.name = StringField.toFirestore(this.name);
    firestoreData.duration = EnumField.toFirestore<LimitationDuration>(this.duration, LimitationDuration.Permanent);
    firestoreData.order = NumberWithDefaultField.toFirestore(this.order, 999);

    return firestoreData;
  }

  public fromOfflineCache(data: Record<string, unknown>): Limitation {
    super.fromOfflineCache(data);

    this.name = StringField.fromOfflineCache(data.name);
    this.duration = EnumField.fromFirestore<LimitationDuration>(data.duration, Object.values(LimitationDuration), LimitationDuration.Permanent);
    this.order = NumberWithDefaultField.fromOfflineCache(data.order, 999);

    return this;
  }

  public toOfflineCache(): Record<string, unknown> {
    const firestoreData: Record<string, unknown> = super.toOfflineCache();

    firestoreData.name = StringField.toOfflineCache(this.name);
    firestoreData.duration = EnumField.toOfflineCache<LimitationDuration>(this.duration, LimitationDuration.Permanent);
    firestoreData.order = NumberWithDefaultField.toOfflineCache(this.order, 999);

    return firestoreData;
  }
}
